import React from "react";
import { connect } from "react-redux";
import { Input } from "../Input";
import { getStorage } from "../../utils/storage";
import icons from "../../constants/icons";
import language from "../../language";
import { fetchBusinessProfile } from "../../queries/profile/merchantProfile";
class MyProfile extends React.Component {
  state = {
    email: "",
    displayName: "",
    phoneNumber: "",
    error: {},
    user: {},
    businessProfile: [],
  };

  componentDidMount = async () => {
    const user = await getStorage();

    this.setState({ user });

    this.getBusinessProfile(true);
  };

  getBusinessProfile = async (isLoading) => {
    const { defaultLanguage } = this.props;
    try {
      this.setState({ isLoading });

      const data = await fetchBusinessProfile(defaultLanguage);

      console.log(data);

      this.setState({
        isLoading: false,
        businessProfile: data,
      });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  onChangeText(field, e) {
    let { error } = this.state;
    delete error[field];

    this.setState({
      [field]: e.target.value,
      error,
    });
  }

  render() {
    return (
      <>
        <div className="row">
          <div className="col-md-4">
            <Input
              placeholder={
                language[this.props.defaultLanguage].name_placeholder
              }
              label={language[this.props.defaultLanguage].name}
              required
              value={this.state?.user?.user?.fullName}
              leftIcon={icons.user}
              disabled
            />
            <Input
              placeholder={
                language[this.props.defaultLanguage]
                  .business_category_placeholder
              }
              label={language[this.props.defaultLanguage].business_category}
              required
              value={this.state.user.businessCategory}
              leftIcon={icons.business}
              disabled
            />
            <Input
              placeholder={
                language[this.props.defaultLanguage].merchant_id_placeholder
              }
              label={language[this.props.defaultLanguage].merchant_id}
              required
              value={this.state.user.merchantID}
              disabled
              leftIcon={icons.merchant}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-md-8">
            <br />
            <div>
              <h3>Business Profile</h3>
            </div>
            {this.state.businessProfile &&
              this.state.businessProfile.map((el, i) => {
                return (
                  <div key={i} className="row">
                    <div className="col-md-6">
                      <Input
                        placeholder={
                          language[this.props.defaultLanguage]
                            .organization_name_id_placeholder
                        }
                        label={
                          language[this.props.defaultLanguage].organization_name
                        }
                        required
                        value={el.name}
                        disabled
                        leftIcon={icons.user}
                      />
                    </div>
                    <div className="col-md-6">
                      <Input
                        placeholder={
                          language[this.props.defaultLanguage]
                            .tax_identification_number_placeholder
                        }
                        label={
                          language[this.props.defaultLanguage]
                            .tax_identification_number
                        }
                        required
                        value={el.taxIdentificationNumber}
                        disabled
                        leftIcon={icons.numbers}
                      />
                    </div>
                    <div className="col-md-6">
                      <Input
                        label={language[this.props.defaultLanguage].industry}
                        required
                        value={el.industryName}
                        disabled
                        leftIcon={icons.industry}
                      />
                    </div>
                    <div className="col-md-6">
                      <Input
                        label={
                          language[this.props.defaultLanguage]
                            .registration_number
                        }
                        required
                        value={el.registrationNumber}
                        disabled
                        leftIcon={icons.numbers}
                      />
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(MyProfile);
